import { render, staticRenderFns } from "./AcademicFormation.vue?vue&type=template&id=22eda230&scoped=true&"
import script from "./AcademicFormation.vue?vue&type=script&lang=ts&"
export * from "./AcademicFormation.vue?vue&type=script&lang=ts&"
import style0 from "./AcademicFormation.vue?vue&type=style&index=0&id=22eda230&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eda230",
  null
  
)

export default component.exports